/* =====================================================================
   Aztral TCG — cosmic trailing cursor
   A holographic glow ring lerps behind the pointer with a small core dot;
   both grow over interactive elements. Native cursor is kept for
   accessibility. Disabled on touch / coarse pointers. Under reduced-motion
   it stays visible but follows instantly with no trail. Self-contained.
   ===================================================================== */
(function () {
  'use strict';

  var mm = window.matchMedia ? window.matchMedia.bind(window) : null;
  var coarse = mm ? mm('(pointer: coarse)').matches : false;
  var noHover = mm ? mm('(hover: none)').matches : false;
  var reduced = mm ? mm('(prefers-reduced-motion: reduce)').matches : false;

  // Touch-only devices: skip entirely, a trailing cursor there is pointless.
  if (coarse && noHover) return;
  if (window.__aztralCursorReady) return;
  window.__aztralCursorReady = true;

  var trail = !reduced;

  var ring = document.createElement('div');
  ring.className = 'az-cursor-ring';
  var dot = document.createElement('div');
  dot.className = 'az-cursor-dot';

  function mount() {
    if (!document.body) return;
    if (reduced) document.documentElement.classList.add('az-cursor-reduced');
    document.documentElement.classList.add('az-cursor-on');
    document.body.appendChild(ring);
    document.body.appendChild(dot);
    try { console.info('[aztral-cursor] mounted', { trail: trail }); } catch (e) {}
  }

  if (document.body) {
    mount();
  } else {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  }

  var targetX = window.innerWidth / 2;
  var targetY = window.innerHeight / 2;
  var ringX = targetX;
  var ringY = targetY;
  var visible = false;
  var rafId = 0;

  function place() {
    if (trail) {
      ringX += (targetX - ringX) * 0.18;
      ringY += (targetY - ringY) * 0.18;
    } else {
      ringX = targetX;
      ringY = targetY;
    }
    ring.style.transform = 'translate3d(' + (ringX - 18) + 'px,' + (ringY - 18) + 'px,0)';
    dot.style.transform = 'translate3d(' + (targetX - 3) + 'px,' + (targetY - 3) + 'px,0)';
  }

  function loop() {
    place();
    rafId = window.requestAnimationFrame(loop);
  }

  function show() {
    if (visible) return;
    visible = true;
    ring.style.opacity = '1';
    dot.style.opacity = '1';
    if (trail) {
      if (!rafId) rafId = window.requestAnimationFrame(loop);
    } else {
      place();
    }
  }

  function onMove(event) {
    if (event.pointerType === 'touch') return;
    targetX = event.clientX;
    targetY = event.clientY;
    show();
    if (!trail) place();
  }

  function hide() {
    visible = false;
    ring.style.opacity = '0';
    dot.style.opacity = '0';
  }

  var interactiveSelector = 'a, button, input, textarea, select, summary, [role="button"], label, .az-card, .az-slab, .az-slot';

  function onOver(event) {
    var t = event.target;
    if (t && t.closest && t.closest(interactiveSelector)) {
      ring.classList.add('is-active');
      dot.classList.add('is-active');
    }
  }

  function onOut(event) {
    var t = event.relatedTarget;
    if (!t || !t.closest || !t.closest(interactiveSelector)) {
      ring.classList.remove('is-active');
      dot.classList.remove('is-active');
    }
  }

  window.addEventListener('pointermove', onMove, { passive: true });
  window.addEventListener('mousemove', onMove, { passive: true });
  document.addEventListener('mouseleave', hide, { passive: true });
  document.addEventListener('pointerover', onOver, { passive: true });
  document.addEventListener('pointerout', onOut, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (rafId) { window.cancelAnimationFrame(rafId); rafId = 0; }
    } else if (visible && trail && !rafId) {
      rafId = window.requestAnimationFrame(loop);
    }
  });
})();
